import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { auditUserComponent } from './audit.user.component';
import { WaitLoadingModule } from '../components/common/waitLoading/waitLoading.module';
import { DossierDetailModule } from '../dossiers/components/dossierDetail.module';
import { DivisionDetailModule } from '../dossiers/components/divisionDetail.module';
import { TranslateModule } from '@ngx-translate/core';
import { OverlayPanelModule } from 'primeng-lts/overlaypanel';
import { PanelModule } from 'primeng-lts/panel';

@NgModule({
  declarations: [auditUserComponent],
  imports: [TranslateModule, CommonModule, WaitLoadingModule, PanelModule, DossierDetailModule, DivisionDetailModule, OverlayPanelModule],
  exports: [auditUserComponent]
})

export class AuditUserModule { }
